import type { Medium } from 'src/types/__generated__/graphql';
import { MediumType } from 'src/types/__generated__/graphql';

/**
 * Returns thumbnail for array of medium.
 * If none of the media is an image, a video or an embed, returns the first medium.
 * @param allMedia Array of media.
 * @param imageOnly Only images are considered as valid thumbnail.
 * @returns Valid thumbnail or first medium of array. Null if empty array.
 */
export type MediumForThumbnail = Omit<Medium, 'createdAt' | 'updatedAt'>;
const getMediaThumbnail = (allMedia: MediumForThumbnail[] | null, imageOnly = false): MediumForThumbnail | null => {
    if (allMedia === null || allMedia.length === 0) {
        return null;
    }
    const firstValidThumbnail = allMedia.find((medium) => {
        if (imageOnly) {
            return medium.type === MediumType.Image;
        }
        return [MediumType.Image, MediumType.Video, MediumType.Embed].includes(medium.type);
    });
    if (!firstValidThumbnail) {
        return allMedia[0];
    }
    return firstValidThumbnail;
};

export default getMediaThumbnail;
